import { render, staticRenderFns } from "./gdpr-confirmation-modal.component.vue?vue&type=template&id=24893964&"
import script from "./gdpr-confirmation-modal.component.vue?vue&type=script&lang=ts&"
export * from "./gdpr-confirmation-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./gdpr-confirmation-modal.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "gdpr-confirmation-modal.component.vue"
export default component.exports